/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignCenterJustifyIcon16Light = forwardRef('TextAlignCenterJustifyIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" }),
        React.createElement("path", { d: "M2 6.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M2.5 9a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" }),
        React.createElement("path", { d: "M2.5 12a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" })));
});
